import '@babel/polyfill';

import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-sanitize';
import 'angular-messages';
import 'angular-jwt';
import 'angular-cookies';
